export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type CheckSubdomainAvailableInput = {
  subdomain: Scalars['String']['input'];
};

export type CheckSubdomainAvailablePayload = {
  __typename?: 'CheckSubdomainAvailablePayload';
  result: SubdomainAvailableResult;
};

/**
 * All input for the create `IpWhitelistPattern` mutation.
 * @permissions: IP_WHITELIST_PATTERN_EDIT,ADMIN
 */
export type CreateIpWhitelistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IpWhitelistPattern` to be created by this mutation. */
  ipWhitelistPattern: IpWhitelistPatternInput;
};

/** The output of our create `IpWhitelistPattern` mutation. */
export type CreateIpWhitelistPatternPayload = {
  __typename?: 'CreateIpWhitelistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IpWhitelistPattern` that was created by this mutation. */
  ipWhitelistPattern?: Maybe<IpWhitelistPattern>;
  /** An edge for our `IpWhitelistPattern`. May be used by Relay 1. */
  ipWhitelistPatternEdge?: Maybe<IpWhitelistPatternsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IpWhitelistPattern` mutation. */
export type CreateIpWhitelistPatternPayloadIpWhitelistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<IpWhitelistPatternsOrderBy>>;
};

/** All input for the create `SubdomainBlacklistPattern` mutation. */
export type CreateSubdomainBlacklistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SubdomainBlacklistPattern` to be created by this mutation. */
  subdomainBlacklistPattern: SubdomainBlacklistPatternInput;
};

/** The output of our create `SubdomainBlacklistPattern` mutation. */
export type CreateSubdomainBlacklistPatternPayload = {
  __typename?: 'CreateSubdomainBlacklistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SubdomainBlacklistPattern` that was created by this mutation. */
  subdomainBlacklistPattern?: Maybe<SubdomainBlacklistPattern>;
  /** An edge for our `SubdomainBlacklistPattern`. May be used by Relay 1. */
  subdomainBlacklistPatternEdge?: Maybe<SubdomainBlacklistPatternsEdge>;
};


/** The output of our create `SubdomainBlacklistPattern` mutation. */
export type CreateSubdomainBlacklistPatternPayloadSubdomainBlacklistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<SubdomainBlacklistPatternsOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/**
 * All input for the `deleteIpWhitelistPattern` mutation.
 * @permissions: IP_WHITELIST_PATTERN_EDIT,ADMIN
 */
export type DeleteIpWhitelistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `IpWhitelistPattern` mutation. */
export type DeleteIpWhitelistPatternPayload = {
  __typename?: 'DeleteIpWhitelistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IpWhitelistPattern` that was deleted by this mutation. */
  ipWhitelistPattern?: Maybe<IpWhitelistPattern>;
  /** An edge for our `IpWhitelistPattern`. May be used by Relay 1. */
  ipWhitelistPatternEdge?: Maybe<IpWhitelistPatternsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IpWhitelistPattern` mutation. */
export type DeleteIpWhitelistPatternPayloadIpWhitelistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<IpWhitelistPatternsOrderBy>>;
};

/** All input for the `deleteSubdomainBlacklistPatternByPattern` mutation. */
export type DeleteSubdomainBlacklistPatternByPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pattern: Scalars['String']['input'];
};

/** The output of our delete `SubdomainBlacklistPattern` mutation. */
export type DeleteSubdomainBlacklistPatternPayload = {
  __typename?: 'DeleteSubdomainBlacklistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SubdomainBlacklistPattern` that was deleted by this mutation. */
  subdomainBlacklistPattern?: Maybe<SubdomainBlacklistPattern>;
  /** An edge for our `SubdomainBlacklistPattern`. May be used by Relay 1. */
  subdomainBlacklistPatternEdge?: Maybe<SubdomainBlacklistPatternsEdge>;
};


/** The output of our delete `SubdomainBlacklistPattern` mutation. */
export type DeleteSubdomainBlacklistPatternPayloadSubdomainBlacklistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<SubdomainBlacklistPatternsOrderBy>>;
};

export type DomainEnvironmentMapping = {
  __typename?: 'DomainEnvironmentMapping';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  portalFullDomain: Scalars['String']['output'];
  portalSubDomain: Scalars['String']['output'];
  /**
   * The primary portal URL for this environment. Returns the custom FQDN URL if one is
   * configured, otherwise the default subdomain-based URL.
   */
  portalUrl: Scalars['String']['output'];
  /**
   * All valid portal URLs for this environment. Always includes the DEFAULT subdomain URL.
   * Also includes a CUSTOM entry if a custom FQDN is configured for this environment.
   */
  portalUrls: Array<PortalUrl>;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `DomainEnvironmentMapping` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DomainEnvironmentMappingCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `portalSubDomain` field. */
  portalSubDomain?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DomainEnvironmentMapping` object types. All fields are combined with a logical ‘and.’ */
export type DomainEnvironmentMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DomainEnvironmentMappingFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DomainEnvironmentMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DomainEnvironmentMappingFilter>>;
  /** Filter by the object’s `portalSubDomain` field. */
  portalSubDomain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** Represents an update to a `DomainEnvironmentMapping`. Fields that are set will be updated. */
export type DomainEnvironmentMappingPatch = {
  portalSubDomain?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `DomainEnvironmentMapping` values. */
export type DomainEnvironmentMappingsConnection = {
  __typename?: 'DomainEnvironmentMappingsConnection';
  /** A list of edges which contains the `DomainEnvironmentMapping` and cursor to aid in pagination. */
  edges: Array<DomainEnvironmentMappingsEdge>;
  /** A list of `DomainEnvironmentMapping` objects. */
  nodes: Array<DomainEnvironmentMapping>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DomainEnvironmentMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DomainEnvironmentMapping` edge in the connection. */
export type DomainEnvironmentMappingsEdge = {
  __typename?: 'DomainEnvironmentMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DomainEnvironmentMapping` at the end of the edge. */
  node: DomainEnvironmentMapping;
};

/** Methods to use when ordering `DomainEnvironmentMapping`. */
export enum DomainEnvironmentMappingsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PortalSubDomainAsc = 'PORTAL_SUB_DOMAIN_ASC',
  PortalSubDomainDesc = 'PORTAL_SUB_DOMAIN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** Exposes all error codes and messages for errors that a service requests can throw. In some cases, messages that are actually thrown can be different, since they can include more details or a single code can used for different errors of the same type. */
export enum ErrorCodesEnum {
  /** Access Token has expired. */
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  /** Access Token is invalid */
  AccessTokenInvalid = 'ACCESS_TOKEN_INVALID',
  /** Access Token is not provided */
  AccessTokenRequired = 'ACCESS_TOKEN_REQUIRED',
  /** Access token verification failed */
  AccessTokenVerificationFailed = 'ACCESS_TOKEN_VERIFICATION_FAILED',
  /** The assertion check for the identifier %s failed. */
  AssertionFailed = 'ASSERTION_FAILED',
  /** Authenticated End User not found. */
  AuthenticatedEndUserNotFound = 'AUTHENTICATED_END_USER_NOT_FOUND',
  /** Authenticated Management Subject not found. */
  AuthenticatedManagementSubjectNotFound = 'AUTHENTICATED_MANAGEMENT_SUBJECT_NOT_FOUND',
  /** A Permission Definition or an EndUserAuthorizationConfig was not found to be passed into Postgraphile build options. This is a development time issue. */
  AuthorizationOptionsMisconfigured = 'AUTHORIZATION_OPTIONS_MISCONFIGURED',
  /** Auth config is invalid. */
  AuthConfigInvalid = 'AUTH_CONFIG_INVALID',
  /** A database operation has failed because of a lock timeout. */
  DatabaseLockTimeoutError = 'DATABASE_LOCK_TIMEOUT_ERROR',
  /** An authorization database error has occurred. The user might not have enough permissions. */
  DatabasePermissionsCheckFailed = 'DATABASE_PERMISSIONS_CHECK_FAILED',
  /** An expected and handled database constraint error has occurred. The actual message will have more information. */
  DatabaseValidationFailed = 'DATABASE_VALIDATION_FAILED',
  /** This is a wrapper error for the original unhandled error of unsupported type. */
  ErrorWrapper = 'ERROR_WRAPPER',
  /** A GraphQL validation error has occurred. Please make sure that the GraphQL request is made with correct syntax or parameters. */
  GraphqlValidationFailed = 'GRAPHQL_VALIDATION_FAILED',
  /** The Identity service is not accessible. Please contact Axinom support. */
  IdentityServiceNotAccessible = 'IDENTITY_SERVICE_NOT_ACCESSIBLE',
  /** An unhandled and unexpected error has occurred. Please contact the service support. */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** The specified subdomain [%s] contains characters which are not allowed. Only a-z, 0-9, and '-' (dash) are allowed. */
  InvalidCharactersInSubDomain = 'INVALID_CHARACTERS_IN_SUB_DOMAIN',
  /** Token is not authorized to perform operations on service state. */
  InvalidTokenType = 'INVALID_TOKEN_TYPE',
  /** Error occurred while trying to fetch signing keys from the JWKS endpoint for the Tenant/Environment/Application. */
  JwksError = 'JWKS_ERROR',
  /** Passed JWT is not a Mosaic End-User Token. Cannot be verified. */
  JwtIsNotMosaicToken = 'JWT_IS_NOT_MOSAIC_TOKEN',
  /** Malformed access token received */
  MalformedToken = 'MALFORMED_TOKEN',
  /** The token is not an Authenticated End-User */
  NotAuthenticatedEndUser = 'NOT_AUTHENTICATED_END_USER',
  /** The object is not a AuthenticatedManagementSubject */
  NotAuthenticatedManagementSubject = 'NOT_AUTHENTICATED_MANAGEMENT_SUBJECT',
  /** The object is not a AuthenticatedRequest */
  NotAuthenticatedRequest = 'NOT_AUTHENTICATED_REQUEST',
  /** The token is not an End-User Application */
  NotEndUserApplication = 'NOT_END_USER_APPLICATION',
  /** The object is not an EndUserAuthenticationContext */
  NotEndUserAuthenticationContext = 'NOT_END_USER_AUTHENTICATION_CONTEXT',
  /** The object is not a GenericAuthenticatedSubject */
  NotGenericAuthenticatedSubject = 'NOT_GENERIC_AUTHENTICATED_SUBJECT',
  /** The object is not a ManagementAuthenticationContext */
  NotManagementAuthenticationContext = 'NOT_MANAGEMENT_AUTHENTICATION_CONTEXT',
  /** The %s is missing required properties: %s. */
  ObjectIsMissingProperties = 'OBJECT_IS_MISSING_PROPERTIES',
  /** The operation is not authorized for [%s]. */
  OperationNotAuthorized = 'OPERATION_NOT_AUTHORIZED',
  /** Could not find a matching signing key to verify the access token. The signing key used to create the token may have been revoked or the Tenant/Environment/Application configuration is erroneous. */
  SigningKeyNotFound = 'SIGNING_KEY_NOT_FOUND',
  /** An application startup error has occurred. The actual message will have more information. */
  StartupError = 'STARTUP_ERROR',
  /** User is authenticated, but subject information was not found. Please contact Axinom Support. */
  SubjectNotFound = 'SUBJECT_NOT_FOUND',
  /** Failed to generate a valid subdomain after [%s] tries. The last attempt resulted in the subdomain [%s]. */
  SubDomainGenerationFailed = 'SUB_DOMAIN_GENERATION_FAILED',
  /** The specified subdomain [%s] is currently in use. */
  SubDomainInUse = 'SUB_DOMAIN_IN_USE',
  /** The subdomain [%s] length cannot exceed 63 chars and the full domain [%s%s] length cannot exceed 253 chars. */
  SubDomainMaxLengthExceeded = 'SUB_DOMAIN_MAX_LENGTH_EXCEEDED',
  /** The specified subdomain [%s] is not allowed. Please try a different value. */
  SubDomainNotAllowed = 'SUB_DOMAIN_NOT_ALLOWED',
  /** The subject has no permissions. */
  Unauthorized = 'UNAUTHORIZED',
  /** Unexpected null or undefined value received. */
  UnexpectedNullUndefined = 'UNEXPECTED_NULL_UNDEFINED',
  /** An unhandled database-related error has occurred. Please contact the service support. */
  UnhandledDatabaseError = 'UNHANDLED_DATABASE_ERROR',
  /** An unhandled error has occurred. Please contact the service support. */
  UnhandledError = 'UNHANDLED_ERROR',
  /** Attempt to create or update an element failed, as it would have resulted in a duplicate element. */
  UniqueConstraintError = 'UNIQUE_CONSTRAINT_ERROR',
  /** User is not authorized to access the operation. */
  UserNotAuthorized = 'USER_NOT_AUTHORIZED',
  /** The User service is not accessible. Please contact Axinom support. */
  UserServiceNotAccessible = 'USER_SERVICE_NOT_ACCESSIBLE',
  /** The %s is not an object. */
  ValueIsNotObject = 'VALUE_IS_NOT_OBJECT',
  /** Websocket not found in ExtendedGraphQLContext. This is a development time issue. A reference to the websocket must be included in Postgraphile build options. */
  WebsocketNotFound = 'WEBSOCKET_NOT_FOUND'
}

/** @permissions: IP_WHITELIST_PATTERN_VIEW,IP_WHITELIST_PATTERN_EDIT,ADMIN */
export type IpWhitelistPattern = {
  __typename?: 'IpWhitelistPattern';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  pattern: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `IpWhitelistPattern` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IpWhitelistPatternCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `pattern` field. */
  pattern?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `IpWhitelistPattern` object types. All fields are combined with a logical ‘and.’ */
export type IpWhitelistPatternFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IpWhitelistPatternFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IpWhitelistPatternFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IpWhitelistPatternFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `IpWhitelistPattern` */
export type IpWhitelistPatternInput = {
  pattern: Scalars['String']['input'];
};

/** Represents an update to a `IpWhitelistPattern`. Fields that are set will be updated. */
export type IpWhitelistPatternPatch = {
  pattern?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A connection to a list of `IpWhitelistPattern` values.
 * @permissions: IP_WHITELIST_PATTERN_VIEW,IP_WHITELIST_PATTERN_EDIT,ADMIN
 */
export type IpWhitelistPatternsConnection = {
  __typename?: 'IpWhitelistPatternsConnection';
  /** A list of edges which contains the `IpWhitelistPattern` and cursor to aid in pagination. */
  edges: Array<IpWhitelistPatternsEdge>;
  /** A list of `IpWhitelistPattern` objects. */
  nodes: Array<IpWhitelistPattern>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IpWhitelistPattern` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IpWhitelistPattern` edge in the connection. */
export type IpWhitelistPatternsEdge = {
  __typename?: 'IpWhitelistPatternsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IpWhitelistPattern` at the end of the edge. */
  node: IpWhitelistPattern;
};

/** Methods to use when ordering `IpWhitelistPattern`. */
export enum IpWhitelistPatternsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PatternAsc = 'PATTERN_ASC',
  PatternDesc = 'PATTERN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a single `IpWhitelistPattern`. */
  createIpWhitelistPattern?: Maybe<CreateIpWhitelistPatternPayload>;
  /** Creates a single `SubdomainBlacklistPattern`. */
  createSubdomainBlacklistPattern?: Maybe<CreateSubdomainBlacklistPatternPayload>;
  /** Deletes a single `IpWhitelistPattern` using a unique key. */
  deleteIpWhitelistPattern?: Maybe<DeleteIpWhitelistPatternPayload>;
  /** Deletes a single `SubdomainBlacklistPattern` using a unique key. */
  deleteSubdomainBlacklistPatternByPattern?: Maybe<DeleteSubdomainBlacklistPatternPayload>;
  /** Updates a single `DomainEnvironmentMapping` using a unique key and a patch. */
  updateDomainEnvironmentMapping?: Maybe<UpdateDomainEnvironmentMappingPayload>;
  /** Updates a single `DomainEnvironmentMapping` using a unique key and a patch. */
  updateDomainEnvironmentMappingByPortalSubDomain?: Maybe<UpdateDomainEnvironmentMappingPayload>;
  /** Updates a single `IpWhitelistPattern` using a unique key and a patch. */
  updateIpWhitelistPattern?: Maybe<UpdateIpWhitelistPatternPayload>;
  /** Updates a single `SubdomainBlacklistPattern` using a unique key and a patch. */
  updateSubdomainBlacklistPatternByPattern?: Maybe<UpdateSubdomainBlacklistPatternPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIpWhitelistPatternArgs = {
  input: CreateIpWhitelistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSubdomainBlacklistPatternArgs = {
  input: CreateSubdomainBlacklistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIpWhitelistPatternArgs = {
  input: DeleteIpWhitelistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSubdomainBlacklistPatternByPatternArgs = {
  input: DeleteSubdomainBlacklistPatternByPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDomainEnvironmentMappingArgs = {
  input: UpdateDomainEnvironmentMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDomainEnvironmentMappingByPortalSubDomainArgs = {
  input: UpdateDomainEnvironmentMappingByPortalSubDomainInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIpWhitelistPatternArgs = {
  input: UpdateIpWhitelistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSubdomainBlacklistPatternByPatternArgs = {
  input: UpdateSubdomainBlacklistPatternByPatternInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

/** A portal URL entry with its type. */
export type PortalUrl = {
  __typename?: 'PortalUrl';
  /** The full URL including scheme. */
  url: Scalars['String']['output'];
  /** Whether this is the default subdomain URL or a custom FQDN. */
  urlType: PortalUrlType;
};

/** Indicates whether a portal URL is the default subdomain-based URL or a custom FQDN. */
export enum PortalUrlType {
  /** A custom FQDN configured for this environment, if set. */
  Custom = 'CUSTOM',
  /** The default portal URL derived from the environment's subdomain and the platform root domain. */
  Default = 'DEFAULT'
}

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  /**
   * Checks if the specified subdomain is allowed to be set.
   *
   * The result will be one of the following values:
   * ALLOWED_FOR_USE
   * CURRENTLY_IN_USE
   * BLOCKED_FOR_USE
   * INVALID_CHARS
   * MAX_LENGTH_EXCEEDED
   */
  checkSubdomainAvailability?: Maybe<CheckSubdomainAvailablePayload>;
  domainEnvironmentMapping?: Maybe<DomainEnvironmentMapping>;
  domainEnvironmentMappingByPortalSubDomain?: Maybe<DomainEnvironmentMapping>;
  /** Reads and enables pagination through a set of `DomainEnvironmentMapping`. */
  domainEnvironmentMappings?: Maybe<DomainEnvironmentMappingsConnection>;
  ipWhitelistPattern?: Maybe<IpWhitelistPattern>;
  /** Reads and enables pagination through a set of `IpWhitelistPattern`. */
  ipWhitelistPatterns?: Maybe<IpWhitelistPatternsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  subdomainBlacklistPatternByPattern?: Maybe<SubdomainBlacklistPattern>;
  /** Reads and enables pagination through a set of `SubdomainBlacklistPattern`. */
  subdomainBlacklistPatterns?: Maybe<SubdomainBlacklistPatternsConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckSubdomainAvailabilityArgs = {
  input: CheckSubdomainAvailableInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryDomainEnvironmentMappingArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDomainEnvironmentMappingByPortalSubDomainArgs = {
  portalSubDomain: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDomainEnvironmentMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DomainEnvironmentMappingCondition>;
  filter?: InputMaybe<DomainEnvironmentMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DomainEnvironmentMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIpWhitelistPatternArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIpWhitelistPatternsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IpWhitelistPatternCondition>;
  filter?: InputMaybe<IpWhitelistPatternFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IpWhitelistPatternsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySubdomainBlacklistPatternByPatternArgs = {
  pattern: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySubdomainBlacklistPatternsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SubdomainBlacklistPatternCondition>;
  filter?: InputMaybe<SubdomainBlacklistPatternFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubdomainBlacklistPatternsOrderBy>>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export enum SubdomainAvailableResult {
  AvailableForUse = 'AVAILABLE_FOR_USE',
  BlockedForUse = 'BLOCKED_FOR_USE',
  CurrentlyInUse = 'CURRENTLY_IN_USE',
  InvalidChars = 'INVALID_CHARS',
  MaxLengthExceeded = 'MAX_LENGTH_EXCEEDED'
}

export type SubdomainBlacklistPattern = {
  __typename?: 'SubdomainBlacklistPattern';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  pattern: Scalars['String']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `SubdomainBlacklistPattern` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type SubdomainBlacklistPatternCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `pattern` field. */
  pattern?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `SubdomainBlacklistPattern` object types. All fields are combined with a logical ‘and.’ */
export type SubdomainBlacklistPatternFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SubdomainBlacklistPatternFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SubdomainBlacklistPatternFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SubdomainBlacklistPatternFilter>>;
  /** Filter by the object’s `pattern` field. */
  pattern?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `SubdomainBlacklistPattern` */
export type SubdomainBlacklistPatternInput = {
  pattern: Scalars['String']['input'];
};

/** Represents an update to a `SubdomainBlacklistPattern`. Fields that are set will be updated. */
export type SubdomainBlacklistPatternPatch = {
  pattern?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `SubdomainBlacklistPattern` values. */
export type SubdomainBlacklistPatternsConnection = {
  __typename?: 'SubdomainBlacklistPatternsConnection';
  /** A list of edges which contains the `SubdomainBlacklistPattern` and cursor to aid in pagination. */
  edges: Array<SubdomainBlacklistPatternsEdge>;
  /** A list of `SubdomainBlacklistPattern` objects. */
  nodes: Array<SubdomainBlacklistPattern>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SubdomainBlacklistPattern` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SubdomainBlacklistPattern` edge in the connection. */
export type SubdomainBlacklistPatternsEdge = {
  __typename?: 'SubdomainBlacklistPatternsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SubdomainBlacklistPattern` at the end of the edge. */
  node: SubdomainBlacklistPattern;
};

/** Methods to use when ordering `SubdomainBlacklistPattern`. */
export enum SubdomainBlacklistPatternsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  Natural = 'NATURAL',
  PatternAsc = 'PATTERN_ASC',
  PatternDesc = 'PATTERN_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateDomainEnvironmentMappingByPortalSubDomain` mutation. */
export type UpdateDomainEnvironmentMappingByPortalSubDomainInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `DomainEnvironmentMapping` being updated. */
  patch: DomainEnvironmentMappingPatch;
  portalSubDomain: Scalars['String']['input'];
};

/** All input for the `updateDomainEnvironmentMapping` mutation. */
export type UpdateDomainEnvironmentMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `DomainEnvironmentMapping` being updated. */
  patch: DomainEnvironmentMappingPatch;
};

/** The output of our update `DomainEnvironmentMapping` mutation. */
export type UpdateDomainEnvironmentMappingPayload = {
  __typename?: 'UpdateDomainEnvironmentMappingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DomainEnvironmentMapping` that was updated by this mutation. */
  domainEnvironmentMapping?: Maybe<DomainEnvironmentMapping>;
  /** An edge for our `DomainEnvironmentMapping`. May be used by Relay 1. */
  domainEnvironmentMappingEdge?: Maybe<DomainEnvironmentMappingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `DomainEnvironmentMapping` mutation. */
export type UpdateDomainEnvironmentMappingPayloadDomainEnvironmentMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<DomainEnvironmentMappingsOrderBy>>;
};

/**
 * All input for the `updateIpWhitelistPattern` mutation.
 * @permissions: IP_WHITELIST_PATTERN_EDIT,ADMIN
 */
export type UpdateIpWhitelistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `IpWhitelistPattern` being updated. */
  patch: IpWhitelistPatternPatch;
};

/** The output of our update `IpWhitelistPattern` mutation. */
export type UpdateIpWhitelistPatternPayload = {
  __typename?: 'UpdateIpWhitelistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IpWhitelistPattern` that was updated by this mutation. */
  ipWhitelistPattern?: Maybe<IpWhitelistPattern>;
  /** An edge for our `IpWhitelistPattern`. May be used by Relay 1. */
  ipWhitelistPatternEdge?: Maybe<IpWhitelistPatternsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IpWhitelistPattern` mutation. */
export type UpdateIpWhitelistPatternPayloadIpWhitelistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<IpWhitelistPatternsOrderBy>>;
};

/** All input for the `updateSubdomainBlacklistPatternByPattern` mutation. */
export type UpdateSubdomainBlacklistPatternByPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `SubdomainBlacklistPattern` being updated. */
  patch: SubdomainBlacklistPatternPatch;
  pattern: Scalars['String']['input'];
};

/** The output of our update `SubdomainBlacklistPattern` mutation. */
export type UpdateSubdomainBlacklistPatternPayload = {
  __typename?: 'UpdateSubdomainBlacklistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SubdomainBlacklistPattern` that was updated by this mutation. */
  subdomainBlacklistPattern?: Maybe<SubdomainBlacklistPattern>;
  /** An edge for our `SubdomainBlacklistPattern`. May be used by Relay 1. */
  subdomainBlacklistPatternEdge?: Maybe<SubdomainBlacklistPatternsEdge>;
};


/** The output of our update `SubdomainBlacklistPattern` mutation. */
export type UpdateSubdomainBlacklistPatternPayloadSubdomainBlacklistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<SubdomainBlacklistPatternsOrderBy>>;
};
